import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DatePicker, TimePicker } from 'antd';
import dateLocale from 'antd/es/date-picker/locale/zh_CN';
import timeLocale from 'antd/es/time-picker/locale/zh_CN';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import { setNotePublishTimeAction } from '../../actions/NotesAction';
import Modal from '../Modal';
import Message from '../Message';
import { martinDispatch } from '../../utils/util';
import styles from './TimePublishModal.scss';

window.moment = moment;

/** 得到离当前时间最近的一个5分钟
 * @param offset {Number} 偏移量，以5分钟为一个单位
 * @return {moment.Moment}
 */
function getNearestTime(offset = 0) {
  const current = +new Date();
  const unit = 1000 * 60 * 5; // 5分钟

  return moment(Math.ceil((current + (unit * offset)) / unit) * unit);
}

function getInitialTime(props) {
  // 这里保证能有15分钟以上的剩余时间
  return props.initialTime ? moment.unix(props.initialTime) : getNearestTime(3);
}

@connect(
  state => ({}),
  dispatch => ({
    $setNotePublishTime: (noteId, publishTime) => {
      return martinDispatch(dispatch, setNotePublishTimeAction(noteId, publishTime));
    },
  }),
)
export default class TimePublishModal extends React.PureComponent {
  static propTypes = {
    noteId: PropTypes.string,
    visible: PropTypes.bool,
    onClose: PropTypes.func,
    initialTime: PropTypes.number,
  };

  constructor(props) {
    super(props);
    const initialTime = getInitialTime(props);
    this.state = {
      date: initialTime,
      time: initialTime,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  componentWillReceiveProps(nextProps) {
    if (this.props.visible !== nextProps.visible && nextProps.visible) {
      const time = getInitialTime(nextProps);
      this.setState({
        date: time,
        time,
      });
    }
  }

  onDateChange = (v) => {
    if (v) {
      this.setState({ date: v });
    }
  };

  onTimeChange = (v) => {
    if (v) {
      this.setState({ time: v });
    }
  };

  disabledDateFn = (current) => {
    return current && current < getNearestTime().startOf('day');
  };

  /**
   * @return {moment.Moment}
   */
  getPublishTime = () => {
    const { date, time } = this.state;
    return moment(date).startOf('day').add(time.hours(), 'hours').add(time.minutes(), 'minutes');
  };

  // 选取的时间大于允许的最近的时间
  checkValid = () => {
    const publishTime = this.getPublishTime();
    return publishTime >= getNearestTime();
  };

  handleSetTime = () => {
    if (this.checkValid()) {
      const { noteId, onClose } = this.props;
      const publishTime = this.getPublishTime();
      this.props.$setNotePublishTime(noteId, publishTime.unix()).then(() => {
        Message.success('定时发文时间设置成功');
        onClose();
      });
    } else {
      Message.error('选取的时间太早了');
    }
  };

  render() {
    const { visible, onClose } = this.props;
    const { date, time } = this.state;

    return (
      <Modal
        width={480}
        title={'定时发文'}
        bodyClass={styles.body}
        footerClass={styles.footer}
        visible={visible}
        maskClosable
        isMiddle
        tips={false}
        onOk={this.handleSetTime}
        onCancel={onClose}
      >
        <div className={styles.title}>选择定时发文的时间：</div>
        <div className={styles.pickers}>
          <DatePicker
            size="large"
            locale={dateLocale}
            value={date}
            disabledDate={this.disabledDateFn}
            onChange={this.onDateChange}
          />
          <TimePicker
            format={'HH:mm'}
            minuteStep={5}
            size="large"
            locale={timeLocale}
            value={time}
            onChange={this.onTimeChange}
          />
        </div>
        <div className={styles.desc}>
          本文章将于
          <span className={styles.time}>
            {date && date.format('YYYY年MM月DD日')} {time && time.format('HH:mm')}
          </span>
          发布。
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TimePublishModal/TimePublishModal.js